export const state = () => ({
  topBoardList: [],
  boardList: [],
  guessList: []
})

export const getters = {}

export const mutations = {
  updateState(state, [key, value]) {
    state[key] = value
  }
}

export const actions = {
  fetchBoardData({ state, commit }, { refresh, type } = { refresh: false }) {
    const stateName = { 5: 'boardList', 6: 'topBoardList' }[type]
    const size = { 5: 7, 6: 3 }[type]
    if (!refresh && state[stateName].length) return state[stateName]
    this.$request('giftsTopBoard', {
      body: { size, type }
    }).then((data = {}) =>
      commit('updateState', [stateName, data.set_list || []])
    )
  },
  async fetchGuess({ commit, rootGetters, dispatch, state }, refresh = false) {
    if (!refresh && state.guessList.length) return state.guessList
    let game_ids = 0
    if (rootGetters.isLogin) {
      const data = await dispatch('user/getRecentlyPlayed', {}, { root: true })
      game_ids = data.map((e) => e.game_id).join(',')
    }
    this.$request('giftsPackageList', {
      body: {
        game_ids,
        page: 1,
        size: 4
      }
    }).then((data = {}) => {
      commit('updateState', ['guessList', data.set_list || []])
    })
  }
}
